import { mapMessage } from '../mappers';
import { fetchWebHistoryMessages, TWebHistoryMessagesResponse } from '../repositories/chats/v2/web/history/messages';
import { TContext } from '../types/context';

// переменная используется для отслеживания события первого сообщения
export const HISTORY_MESSAGES_REQUEST_LIMIT = 100;

interface IWebHistoryMessagesRequestParameters {
  chatId: string;
  /** Дата, после которой нужно получить сообщения  ISO-8601, пример: 2022-08-01T01:34:03.123456+00:00. **/
  createdAt?: string;
  rowVersionsHash?: string;
}

type TFetchWebHistoryMessagesParams = {
  parameters: IWebHistoryMessagesRequestParameters;
  cookies?: string;
};

export async function fetchHistoryMessages(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchWebHistoryMessagesParams,
) {
  try {
    const { response, statusCode }: TWebHistoryMessagesResponse = await fetchWebHistoryMessages({
      httpApi,
      parameters: {
        ...parameters,
        limit: HISTORY_MESSAGES_REQUEST_LIMIT,
      },
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось получить обновление чата',
        domain: 'src/shared/services/fetchHistoryMessages.ts [fetchHistoryMessages]',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return { response: null, error: response };
    }

    return {
      response: {
        ...response,
        messages: response.messages.map(mapMessage),
      },
      error: null,
    };
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchHistoryMessages.ts [fetchHistoryMessages]',
      description: 'Ошибка при получении обновления чата',
    });

    return { response: null, error };
  }
}
